import React from 'react';
import { cn } from '@/lib/utils';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import {
  CONTROL_LABELS,
  TIMER_SOUND_LABELS,
  TimerSoundCue,
  TimerSoundSettings,
} from '../../../const/timer';

interface TimerSoundSettingsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  settings: TimerSoundSettings;
  onToggle: (cue: TimerSoundCue) => void;
}

const CUE_ORDER: TimerSoundCue[] = ['start', 'preAlarm', 'mainEnd', 'writingEnd'];

const TimerSoundSettingsDialog: React.FC<TimerSoundSettingsDialogProps> = ({
  open,
  onOpenChange,
  settings,
  onToggle,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-sm rounded-xl">
      <DialogHeader>
        <DialogTitle>{CONTROL_LABELS.soundSettings}</DialogTitle>
        <DialogDescription>{CONTROL_LABELS.soundSettingsHint}</DialogDescription>
      </DialogHeader>
      <div className="divide-y divide-gray-100 dark:divide-gray-800">
        {CUE_ORDER.map((cue) => {
          const checked = settings[cue];
          const { title, description } = TIMER_SOUND_LABELS[cue];
          const id = `timer-sound-${cue}`;
          return (
            <div key={cue} className="flex items-center justify-between gap-4 py-3">
              <label htmlFor={id} className="min-w-0 cursor-pointer">
                <span className="block text-sm font-semibold text-gray-800 dark:text-gray-100">{title}</span>
                <span className="block text-xs text-gray-500 dark:text-gray-400">{description}</span>
              </label>
              <button
                id={id}
                type="button"
                role="switch"
                aria-checked={checked}
                onClick={() => onToggle(cue)}
                className={cn(
                  'relative inline-flex h-5 w-9 flex-shrink-0 items-center rounded-full transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500',
                  checked ? 'bg-blue-600' : 'bg-gray-200 dark:bg-gray-700'
                )}
              >
                <span
                  className={cn(
                    'inline-block h-3.5 w-3.5 rounded-full bg-white shadow transition-transform duration-200',
                    checked ? 'translate-x-[18px]' : 'translate-x-[3px]'
                  )}
                />
              </button>
            </div>
          );
        })}
      </div>
    </DialogContent>
  </Dialog>
);

export default TimerSoundSettingsDialog;
